import type { App } from 'vue'
import AppAnimatedDot from './app-animated-dot.vue'
import AppCodeBlock from './app-code-block.vue'
import AppErrorMsg from './app-error-msg.vue'
import AppImg from './app-img.vue'
import AppInformation from './app-information.vue'
import AppInformationVertical from './app-information-vertical.vue'
import AppPagination from './app-pagination.vue'
import AppSelectDropdown from './app-select-dropdown.vue'
import { useButton } from './button'
import { useCard } from './card'
import ComponentInformation from './component-information.vue'
import FaIcon from './fa-icon.vue'
import { useInput } from './input'
import useModal from './modal'
import { useSubMenu } from './submenu'
import { useTable } from './table'
import AppBadge from './ui/badge/Badge.vue'

export default {
  install (app: App) {
    app.use(useModal)
    app.use(useInput)
    app.use(useButton)
    app.use(useCard)
    app.use(useSubMenu)
    app.use(useTable)
    // shadcn-vue
    app.component('AppBadge', AppBadge)
    // shadcn-vue
    app.component('AppErrorMsg', AppErrorMsg)
    app.component('AppCodeBlock', AppCodeBlock)
    app.component('AppAnimatedDot', AppAnimatedDot)
    app.component('AppPagination', AppPagination)
    app.component('AppInformation', AppInformation)
    app.component('AppInformationVertical', AppInformationVertical)
    app.component('AppImg', AppImg)
    app.component('FaIcon', FaIcon)
    app.component('ComponentInformation', ComponentInformation)
    app.component('AppSelectDropdown', AppSelectDropdown)
  },
}

declare module '@vue/runtime-core' {
  export interface GlobalComponents {
    // shadcn-vue
    AppBadge: typeof AppBadge,
    // shadcn-vue
    FaIcon: typeof FaIcon,
    AppCodeBlock: typeof AppCodeBlock,
    AppErrorMsg: typeof AppErrorMsg,
    AppAnimatedDot: typeof AppAnimatedDot,
    AppPagination: typeof AppPagination,
    AppInformation: typeof AppInformation,
    AppInformationVertical: typeof AppInformationVertical,
    AppImg: typeof AppImg,
    ComponentInformation: typeof ComponentInformation,
    AppSelectDropdown: typeof AppSelectDropdown,
  }
}
